module.exports = __webpack_public_path__ + "static/img/bg-id.1192f2a0.webp";